import { createContext, useState } from "react";

export const createMessage = createContext();

export const MessageProvider = ({ children }) => {
    const [message, setMessage] = useState(false);
    return <createMessage.Provider value={[message, setMessage]}>{children}</createMessage.Provider>;
};
